import { ContactInformationData } from './contact-information-data';

export interface SalesOfficeData {
  salesOfficeCode: string;
  lastModified: string;
  countryCode: string;
  salesOfficeGroup: string;
  totalCount: string;
  contacts: Array<ContactInformationData>;
}
